import { render, staticRenderFns } from "./robotArmPose.vue?vue&type=template&id=4ddef263&scoped=true&"
import script from "./robotArmPose.vue?vue&type=script&lang=js&"
export * from "./robotArmPose.vue?vue&type=script&lang=js&"
import style0 from "./robotArmPose.vue?vue&type=style&index=0&id=4ddef263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddef263",
  null
  
)

export default component.exports